module.exports = __webpack_public_path__ + "img/img-59.c3be8fc8.png";